export default "__VITE_ASSET__ae3715ef__"